import React, { useState, useEffect } from "react";

import { toast } from "react-toastify";

import { makeStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import CircularProgress from "@material-ui/core/CircularProgress";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Chip from "@material-ui/core/Chip";
import Checkbox from "@material-ui/core/Checkbox";
import ListItemText from "@material-ui/core/ListItemText";

import api from "../../services/api";
import toastError from "../../errors/toastError";

const useStyles = makeStyles(theme => ({
	root: {
		display: "flex",
		flexWrap: "wrap",
	},
	btnWrapper: {
		position: "relative",
	},
	buttonProgress: {
		color: green[500],
		position: "absolute",
		top: "50%",
		left: "50%",
		marginTop: -12,
		marginLeft: -12,
	},
	chips: {
		display: "flex",
		flexWrap: "wrap",
	},
	chip: {
		margin: 2,
	},
}));

const TicketTagModal = ({ open, onClose, ticketId, ticketTags }) => {
	const classes = useStyles();

	const [tags, setTags] = useState([]);
	const [selectedTags, setSelectedTags] = useState([]);
	const [isSubmitting, setIsSubmitting] = useState(false);

	useEffect(() => {
		(async () => {
			try {
				const { data } = await api.get("/tags");
				setTags(data);
			} catch (err) {
				toastError(err);
			}
		})();
	}, []);

	useEffect(() => {
		if (ticketTags) {
			setSelectedTags(ticketTags.map(t => t.id));
		}
	}, [ticketTags]);

	const handleClose = () => {
		onClose();
	};

	const handleChange = e => {
		setSelectedTags(e.target.value);
	};

	const handleSaveTags = async () => {
		setIsSubmitting(true);
		try {
			const tagsToSync = selectedTags.map(id => ({ id }));
			await api.post(`/tags/sync/${ticketId}`, { tags: tagsToSync });
			toast.success("Etiquetas salvas com sucesso!");
			handleClose();
		} catch (err) {
			toastError(err);
		}
		setIsSubmitting(false);
	};

	return (
		<div className={classes.root}>
			<Dialog open={open} onClose={handleClose} scroll="paper" fullWidth maxWidth="xs">
				<DialogTitle>Gerenciar Etiquetas</DialogTitle>
				<DialogContent dividers>
					<FormControl fullWidth margin="dense" variant="outlined">
						<InputLabel>Selecione as Etiquetas</InputLabel>
						<Select
							multiple
							labelWidth={160}
							value={selectedTags}
							onChange={handleChange}
							MenuProps={{
								anchorOrigin: {
									vertical: "bottom",
									horizontal: "left",
								},
								transformOrigin: {
									vertical: "top",
									horizontal: "left",
								},
								getContentAnchorEl: null,
							}}
							renderValue={selected => (
								<div className={classes.chips}>
									{selected?.length > 0 &&
										selected.map(id => {
											const tag = tags.find(q => q.id === id);
											return tag ? (
												<Chip
													key={id}
													style={{ backgroundColor: tag.color, color: "#fff", fontWeight: "bold" }}
													variant="default"
													label={tag.name}
													className={classes.chip}
													size="small"
													onMouseDown={(e) => e.stopPropagation()}
													onDelete={(e) => {
														setSelectedTags(prev => prev.filter(t => t !== id));
													}}
												/>
											) : null;
										})}
								</div>
							)}
						>
							{tags.map(tag => (
								<MenuItem key={tag.id} value={tag.id}>
									<Checkbox checked={selectedTags.indexOf(tag.id) > -1} />
									<ListItemText primary={tag.name} />
								</MenuItem>
							))}
						</Select>
					</FormControl>
				</DialogContent>
				<DialogActions>
					<Button
						onClick={handleClose}
						color="secondary"
						disabled={isSubmitting}
						variant="outlined"
					>
						Cancelar
					</Button>
					<Button
						onClick={handleSaveTags}
						color="primary"
						disabled={isSubmitting}
						variant="contained"
						className={classes.btnWrapper}
					>
						Salvar
						{isSubmitting && (
							<CircularProgress size={24} className={classes.buttonProgress} />
						)}
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	);
};

export default TicketTagModal;
